module.exports = __webpack_public_path__ + "images/root/mainVisual_appeal_pc_2dac5589cdb1af79e6d9d117d71b457e.svg";